import { render, staticRenderFns } from "./CoursewareManagement.vue?vue&type=template&id=50585d74&scoped=true"
import script from "./CoursewareManagement.vue?vue&type=script&lang=js"
export * from "./CoursewareManagement.vue?vue&type=script&lang=js"
import style0 from "./CoursewareManagement.vue?vue&type=style&index=0&id=50585d74&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50585d74",
  null
  
)

export default component.exports